import routesLimited, { hasProperty } from '@/constants/routesLimited'
import { castRouteIds } from 'plugins/router/routes/castRouteIds'
import type { RouteRecordRaw } from 'vue-router'

const faqCreate: RouteRecordRaw = {
	component: () => import('@/components/modules/Faqs/CreateEdit.vue'),
	name: 'faqCreate',
	path: 'create',
	meta: {
		limited: routesLimited.can_post,
		title: 'routeTitle.createFaqEntry',
	},
	props: { multiple: false },
}
const faqEdit: RouteRecordRaw = {
	component: () => import('@/components/modules/Faqs/CreateEdit.vue'),
	name: 'faqEdit',
	path: ':id/edit',
	meta: {
		limited: routesLimited.can_update,
		title: 'routeTitle.editFaqCategory',
	},
	props: castRouteIds,
}
const faqCategoryCreate: RouteRecordRaw = {
	component: () =>
		import('@/components/modules/Faqs/Categories/CreateEdit.vue'),
	meta: {
		limited: routesLimited.can_post,
		title: 'routeTitle.createFaqCategory',
		icon: 'fas fa-th-large',
	},
	name: 'faqCategoryCreate',
	path: 'category/create/',
}
const faqCategoryEdit: RouteRecordRaw = {
	component: () =>
		import('@/components/modules/Faqs/Categories/CreateEdit.vue'),
	name: 'faqCategoryEdit',
	path: 'category/:id/edit',
	meta: {
		limited: routesLimited.can_update,
		icon: 'fas fa-th-large',
		title: 'routeTitle.editFaqCategory',
	},
	props: castRouteIds,
}
const faq: RouteRecordRaw = {
	children: [faqCreate, faqEdit, faqCategoryCreate, faqCategoryEdit],
	component: () => import('components/modules/Faqs/Categories/List.vue'),
	meta: {
		icon: 'fa-fw fas fa-question-square',
		nav: true,
		tour: true,
		ordering: 8,
		title: 'FAQ',
		auth: true,
		limited: [
			routesLimited.isAdminOrTeam,
			{
				method: hasProperty,
				parameter: {
					store: 'user',
					getter: 'permissions',
					property: 'role.faq_enabled',
					value: true,
				},
			},
		],
		subs: [routesLimited.subModules.faqs],
	},
	name: 'faqs',
	path: '/faqs',
}

export const faqRoutes: RouteRecordRaw[] = [
	faq,
	faqEdit,
	faqCreate,
	faqCategoryEdit,
	faqCategoryCreate,
]

export { faq }
